// import { socket } from '../../utils/socketIo';
import {
  useState,
  useEffect,
  // useRef
} from 'react';
// import Draggable from 'react-draggable';
import TimeRangePickerGeneric from '../../components/time-range-picker-generic/time-range-picker.component';
// import useWindowDimensions from '../../utils/useWindowDimensions.hook';
// import Draggable from 'react-draggable';
import {
  Typography,
  Paper,
  Box,
  Container,
  FormControl,
  TextField,
  // useMediaQuery,
  Grid,
} from '@mui/material';
// import { ResizableBox } from 'react-resizable';
// import { motion } from 'framer-motion';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import CustomButtonMui from '../../components/custom-button-mui/custom-button.component';

import { useSelector, useDispatch } from 'react-redux';
import {
  getFlightIdsStart,
  setDof,
  setFilterTimeStart,
  setFilterTimeEnd,
  setDestination,
  // setFilteredFlightIds,
  filterFlightIdsStart,
  // setCustomerDataLoading,
  // getCustomerDataStart,
  // setFlightIdsLoading
} from '../../redux/valetData/valetData.actions';

// import { getNewHireDataStart } from '../../redux/new-hire/new-hire.actions';
import {
  selectDof,
  selectFilterTimeStart,
  selectFilterTimeEnd,
  selectCustomerDataLoading,
  selectFlightCustomerData,
  selectFlightIdsLoading,
  selectDestination,
  // selectFlightIds,
  selectFlightTimes,
  // selectFilteredFlightIds,
} from '../../redux/valetData/valetData.selector';

import ValetVizCustomerCard from '../../components/valet-viz/valet-viz-customer-card.component';

// import JSONEditorComponent from '../../components/json-editor/json-editor.component';

// import DepartmentComponent from '../../components/new-hire-editor/department.component';
import _ from 'lodash';
import uuid from 'react-uuid';

const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#b71c1c',
      light: '#e57373',
      text: '#000000',
    },
    secondary: {
      main: '#e0e0e0',
      light: '#ffffff',
      dark: '#aeaeae',
    },
    warning: {
      main: '#ff9100',
      light: '#ffc947',
    },
    error: {
      main: '#ff0000',
    },
  },
};

const StationTextField = ({ value, onChange, disabled }) => {
  return (
    <TextField
      label="Station"
      placeholder="(e.g. DAL)"
      variant="filled"
      margin="normal"
      value={value}
      // error={dof === '' ? false : !value}
      onChange={onChange}
      sx={{
        minWidth: 100,
        maxWidth: 200,
        m: 1,
        borderRadius: 4,
        zIndex: 0,
      }}
      disabled={disabled}
    />
  );
};

const ValetPage = () => {
  let theme = createTheme(deepmerge(themeOptions));
  let [foucused, setFocused] = useState(true);
  let dof = useSelector(selectDof);
  let startTime = useSelector(selectFilterTimeStart);
  let endTime = useSelector(selectFilterTimeEnd);
  let destination = useSelector(selectDestination);
  let customerDataLoading = useSelector(selectCustomerDataLoading);
  let flightCustomerData = useSelector(selectFlightCustomerData);
  let flightTimes = useSelector(selectFlightTimes);
  let flightIdsLoading = useSelector(selectFlightIdsLoading);
  // const [reWidth, setReWidth] = useState(425);
  const [searchFor, setSearchFor] = useState('');
  // const isSmall = useMediaQuery(theme.breakpoints.down('sm')); //600px

  const [currCustomers, setCurrCustomer] = useState([]);

  const checkName = (name, str) => {
    let pattern = str
      .split('')
      .map((x) => {
        return `(?=.*${x})`;
      })
      .join('');
    let regex = new RegExp(`${pattern}`, 'g');
    return name.match(regex);
  };
  // let flightIds = useSelector(selectFilteredFlightIds);
  // let flightTimes = useSelector(selectFlightTimes);

  let dispatch = useDispatch();

  // const onResize = (event, { element, size, handle }) => {
  //   setReWidth(size.width);
  // };

  const setEndTime = (time) => {
    dispatch(setFilterTimeEnd(time));
  };

  const setStartTime = (time) => {
    dispatch(setFilterTimeStart(time));
  };

  const setDofHandler = (date) => {
    dispatch(setDof(date));
    if (date !== '') dispatch(getFlightIdsStart(dof));
  };

  const setDestinationHandler = (e) => {
    e.preventDefault();
    let destination = e.target.value;
    dispatch(setDestination(destination));
    filterFlightData();
    setSearchFor('');
  };

  const filterFlightData = () => {
    dispatch(filterFlightIdsStart());
    // dispatch(getCustomerDataStart());
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!dof || !destination || !startTime || !endTime || !searchFor) {
      alert('Please fill out all fields');
      return;
    }
    filterFlightData();
    // dispatch(getFlightIdsStart(dof));
  };

  useEffect(() => {
    // dispatch(setDof(undefined));
    // dispatch(getCustomerDataStart());
    // eslint-disable-next-line
  }, [destination]);

  useEffect(() => {
    if (
      !searchFor ||
      // searchFor === '' ||
      flightCustomerData === null ||
      customerDataLoading
    ) {
      return;
    }
    let customers = [];
    Object.keys(flightCustomerData)
      .filter((flightId) =>
        //For each flight check if customer exists
        flightCustomerData[flightId].some(
          (customer) =>
            customer.lastName.toLowerCase().includes(searchFor.toLowerCase()) ||
            checkName(customer.lastName.toLowerCase(), searchFor.toLowerCase())
        )
      )
      .map((flightId) => {
        return _.filter(flightCustomerData[flightId], (customer) => {
          return (
            customer.lastName.toLowerCase().includes(searchFor.toLowerCase()) ||
            checkName(customer.lastName.toLowerCase(), searchFor.toLowerCase())
          );
        });
      })
      .map((customer) => {
        if (customer.length > 0) {
          customer.forEach((cust) => {
            customers.push(cust);
          });
        }
        return customers;
      });
    setCurrCustomer(customers);
    // eslint-disable-next-line
  }, [flightCustomerData, searchFor, destination]);

  return (
    <ThemeProvider theme={theme}>
      <Container
        // maxWidth='xl'
        disableGutters
        sx={{
          minWidth: `100vw`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Paper
          sx={{
            padding: { lg: '3rem', xs: 3 },
            // minHeight: 1000,
            minWidth: '90vw',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <FormControl
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 10,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                textAlign: 'center',
                color: 'primary.text',
              }}
            >
              Valet Query
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { lg: 'row', xs: 'column' },
                m: 5,
                width: '90%',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <TextField
                key="dof-text-field"
                label="Date of Flight"
                placeholder="MM/DD/YYYY"
                variant="filled"
                margin="normal"
                type="date"
                focused={foucused}
                value={dof}
                error={!dof}
                onChange={(e) => {
                  setDofHandler(e.target.value);
                  setFocused(false);
                }}
                sx={{
                  minWidth: 100,
                  maxWidth: 200,
                  m: 1,
                  borderRadius: 4,
                  zIndex: 0,
                }}
              />

              <StationTextField
                value={destination}
                onChange={setDestinationHandler}
                disbaled={!dof || flightIdsLoading || customerDataLoading}
              />

              <TextField
                key="lastname-text-field"
                label="Search For"
                placeholder="Last Name"
                variant="filled"
                margin="normal"
                value={searchFor}
                error={dof === '' ? false : !searchFor}
                onChange={(e) => setSearchFor(e.target.value)}
                sx={{
                  minWidth: 100,
                  maxWidth: 200,
                  m: 1,
                  borderRadius: 4,
                  zIndex: 0,
                }}
                required
                disabled={!dof || flightIdsLoading || customerDataLoading}
              />
            </Box>
            <Typography
              variant="h5"
              sx={{
                textAlign: 'left',
                width: '100%',
                ml: 7,
                my: 3,
                color: 'primary.text',
              }}
            >
              Time Filtering
            </Typography>
            <TimeRangePickerGeneric
              setEnd={setEndTime}
              setStart={setStartTime}
              start={startTime}
              end={endTime}
              onChange={filterFlightData}
            />
            <CustomButtonMui
              variant="outlined"
              loading={flightIdsLoading || customerDataLoading}
              sx={{ width: '40%', height: 50, textAlign: 'center' }}
              onClick={handleSearch}
            >
              Search
            </CustomButtonMui>
          </FormControl>
          {searchFor && flightCustomerData && (
            <>
              <Typography
                variant="h5"
                sx={{
                  textAlign: 'left',
                  width: '100%',
                  ml: 7,
                  my: 3,
                  color: 'primary.text',
                }}
              >
                {currCustomers.length} Customers Found
              </Typography>

              <Grid
                container
                rowSpacing={8}
                columnSpacing={{ xs: 1, sm: 2, md: 5, lg: 10, xl: 15 }}
                sx={{ justifyContent: 'center' }}
              >
                {currCustomers?.map((customer) => {
                  return (
                    <Grid
                      item
                      key={uuid()}
                      xs={1}
                      sm={6}
                      md={4}
                      lg={4}
                      xl={3}
                      sx={{ maxWidth: '100%' }}
                    >
                      <ValetVizCustomerCard
                        key={uuid()}
                        customer={customer}
                        flightTimes={{ ...flightTimes[customer.flightId] }}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </>
          )}
        </Paper>
      </Container>
    </ThemeProvider>
  );
};

export default ValetPage;
